import { Plane, BriefcaseBusiness, CalendarDays, BusFront, Clock3, MapPinned, ArrowUpRight } from "lucide-react";

const icons = { plane: Plane, briefcase: BriefcaseBusiness, calendar: CalendarDays, van: BusFront, clock: Clock3, map: MapPinned };

export function ServiceIcon({ name }) {
  const Icon = icons[name] || ArrowUpRight;
  return <Icon aria-hidden="true" strokeWidth={1.5} />;
}